export default __webpack_public_path__ + "static/media/suhas.8eea7e70.jpg";